import { Card, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { faqToolOptions } from "../../../../Common/consts/faqToolOptions";
import FaqToolButton from "../FaqToolButton/FaqToolButton";
import styles from "./FaqToolsFilter.module.scss";

const TOOLS_PARAM = "tools";
const validToolNames = new Set(faqToolOptions.map((t) => t.toolName));

interface FaqToolsFilterProps {
  toggleToolSelect: (tools: string[]) => void;
  tools: string[];
}

const areSameTools = (a: string[], b: string[]) =>
  a.length === b.length && a.every((tool, index) => tool === b[index]);

const FaqToolsFilter = ({
  toggleToolSelect,
  tools,
}: FaqToolsFilterProps): JSX.Element => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [pendingTools, setPendingTools] = useState(() =>
    Array.from(new Set(searchParams.getAll(TOOLS_PARAM))).filter((tool) =>
      validToolNames.has(tool)
    )
  );

  useEffect(() => {
    if (pendingTools.length) {
      const toolsToApply = pendingTools.filter((tool) => !tools.includes(tool));
      if (toolsToApply.length) {
        toggleToolSelect(toolsToApply);
      }
      setPendingTools([]);
      return;
    }

    if (areSameTools(searchParams.getAll(TOOLS_PARAM), tools)) {
      return;
    }

    const params = new URLSearchParams(searchParams);
    params.delete(TOOLS_PARAM);
    tools.forEach((tool) => params.append(TOOLS_PARAM, tool));
    setSearchParams(params, { replace: true });
  }, [tools, pendingTools, searchParams]);

  return (
    <Card className={styles.faqToolsFilter}>
      <div className={styles.faqToolsFilter__header}>
        <Typography variant="h6">Filter articles by tool</Typography>
      </div>
      <div className={styles.faqToolsFilter__content}>
        {faqToolOptions.map((t) => (
          <FaqToolButton
            key={t.toolKey}
            {...t}
            isSelected={tools.some((tool) => tool === t.toolName)}
            toggleToolSelect={toggleToolSelect}
          />
        ))}
      </div>
    </Card>
  );
};

export default FaqToolsFilter;
